import type { BreadcrumbItem } from '@/components/Breadcrumb/types'

export const preCallTestBreadcrumbList: BreadcrumbItem[] = [
  {
    route: '/',
    label: 'Início',
  },
  {
    route: '/teste-de-chamada',
    label: 'Teste de chamada',
    active: true,
  },
]
